import { DonutChart } from "./DonutChart";

export const InsightCircle = (props: {
  flagkey: string;
  tooltip: string;
  data: { color: string; label: string; value: number }[];
  totalFlags?: number;
}) => {
  return (
    <div
      data-tip
      data-for={props.tooltip}
      className="flex px-3 flex-1 items-center truncate"
    >
      <div className="w-16 relative">
        <DonutChart data={props.data} cutout={20} enableTooltip={false}>
          <p
            className={
              "absolute w-16 text-center text-xl flex items-center justify-center h-full"
            }
          >
            {props.totalFlags ?? 0}
          </p>
        </DonutChart>
      </div>
    </div>
  );
};
